module.exports = __webpack_public_path__ + "static/media/acmemarkets.a5131b90.svg";